import { useAppSelector } from "./hooks";

import { posthogClient } from "../config/posthog";

export const useSelections = () => {
  //   const [selections, setSelections] = useState<string[]>([]);
  //   const networkSelections = useAppSelector(
  //     (state) => state.network?.selections,
  //   );
  //   const listsSelections = useAppSelector((state) => state.lists?.selections);
  //   const profileValue = useAppSelector((state) => state.profile?.value);

  //   useEffect(() => {
  //     console.log("networkSelections", networkSelections);
  //     if (window.location.pathname.includes("network")) {
  //       setSelections(networkSelections ?? []);
  //       console.log('set')
  //     } else if (window.location.pathname.includes("lists")) {
  //       setSelections(listsSelections ?? []);
  //     } else if (window.location.pathname.includes("profiles")) {
  //       profileValue?._id ? [profileValue?._id] : [];
  //     }
  //     setSelections([]);
  //   }, [networkSelections, listsSelections, profileValue?._id]);

  //   return selections;

  return useAppSelector((state) => {
    return state.profile?.value?._id;
  });
};

const defaultRuleMap = {
  brand: "Branding",
  text: "Content/Copy",
  preference: "Preference",
  technical: "Technical",
  legal: "Legal",
};

export const getAiRuleMap = (): { [key: string]: string } => {
  const aiRulesMapFlag =
    posthogClient.getFeatureFlagPayload("ai-rules-available");

  if (aiRulesMapFlag) {
    return aiRulesMapFlag as { [key: string]: string };
  }

  return defaultRuleMap;
};

export const atomicTaskMap: { [key: string]: string } = {
  AT1: "AT1 - Previous Feedback",
  AT2: "AT2 - Required Legal Text",
  AT3: "AT3 - Copy Errors",
  AT4: "AT4 - Deliverable Specs",
  AT5: "AT5 - Logo Usage",
  AT6: "AT6 - SKU/Product Variant",
  AT7: "AT7 - Legal Accuracy",
  AT8: "AT8 - Claims Wording",
  AT9: "AT9 - Layout Guidelines",
  AT10: "AT10 - Channel Requirements",
};
